export const options = [
  {
    label: 'Daily',
    value: 'daily',
  },
  {
    label: 'Weekly',
    value: 'weekly',
  },
  {
    label: 'Monthly',
    value: 'monthly',
  },
]

export const dayOptions = [
  {
    label: 'Monday',
    value: 'Monday',
  },
  {
    label: 'Tuesday',
    value: 'Tuesday',
  },
  {
    label: 'Wednesday',
    value: 'Wednesday',
  },
  {
    label: 'Thursday',
    value: 'Thursday',
  },
  {
    label: 'Friday',
    value: 'Friday',
  },
  {
    label: 'Saturday',
    value: 'Saturday',
  },
  {
    label: 'Sunday',
    value: 'Sunday',
  },
]

export const monthOptions = [
  {
    label: 'January',
    value: '01',
  },
  {
    label: 'February',
    value: '02',
  },
  {
    label: 'March',
    value: '03',
  },
  {
    label: 'April',
    value: '04',
  },
  {
    label: 'May',
    value: '05',
  },
  {
    label: 'June',
    value: '06',
  },
  {
    label: 'July',
    value: '07',
  },
  {
    label: 'August',
    value: '08',
  },
  {
    label: 'September',
    value: '09',
  },
  {
    label: 'October',
    value: '10',
  },
  {
    label: 'November',
    value: '11',
  },
  {
    label: 'December',
    value: '12',
  },
]

export const ordinalOptions = [
  {
    label: '1st of every month',
    value: '01',
  },
  {
    label: '2nd of every month',
    value: '02',
  },
  {
    label: '3rd of every month',
    value: '03',
  },
  {
    label: '4th of every month',
    value: '04',
  },
  {
    label: '5th of every month',
    value: '05',
  },
  {
    label: '6th of every month',
    value: '06',
  },
  {
    label: '7th of every month',
    value: '07',
  },
  {
    label: '8th of every month',
    value: '08',
  },
  {
    label: '9th of every month',
    value: '09',
  },
  {
    label: '10th of every month',
    value: '10',
  },
  {
    label: '11th of every month',
    value: '11',
  },
  {
    label: '12th of every month',
    value: '12',
  },
  {
    label: '13th of every month',
    value: '13',
  },
  {
    label: '14th of every month',
    value: '14',
  },
  {
    label: '15th of every month',
    value: '15',
  },
  {
    label: '16th of every month',
    value: '16',
  },
  {
    label: '17th of every month',
    value: '17',
  },
  {
    label: '18th of every month',
    value: '18',
  },
  {
    label: '19th of every month',
    value: '19',
  },
  {
    label: '20th of every month',
    value: '20',
  },
  {
    label: '21th of every month',
    value: '21',
  },
  {
    label: '23th of every month',
    value: '23',
  },
  {
    label: '24th of every month',
    value: '24',
  },
  {
    label: '25th of every month',
    value: '25',
  },
  {
    label: '26th of every month',
    value: '26',
  },
  {
    label: '27th of every month',
    value: '27',
  },
  {
    label: '28th of every month',
    value: '28',
  },
  {
    label: '29th of every month',
    value: '29',
  },
  {
    label: '30th of every month',
    value: '30',
  },
  {
    label: '31st of every month',
    value: '31',
  },
]
